import { defineStore } from 'pinia';
import { FullEvent } from '@front-app/services/EventsApi/EventModel';
import { getEventById } from '@front-app/services/EventsApi/EventsApi';
import { EventRoleRequest, updateEventMemberRole } from '@front-app/services/EventsApi/EventsMemberApi';

interface StoreState {
	events: FullEvent[];
}

/**
 * The purpose of this store is to keep track of all FullEvent data.
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const createEventStore = (name: string) => defineStore(name, {
	state: (): StoreState => ({
		events: [],
	}),
	getters: {
		getById(state) {
			return (requestedEventId: string) => state.events
				.find(({ id }) => id === requestedEventId);
		},
	},
	actions: {
		storeEvents(events: FullEvent[]) {
			this.$patch((state) => {
				const eventIds = events.map(({ id }) => id);
				const oldEvents = state.events.filter(({ id }) => !eventIds.includes(id));
				state.events = oldEvents.concat(events);
			});
		},
		async updateMemberRole(eventId: string, targetRole: EventRoleRequest) {
			await updateEventMemberRole(eventId, targetRole);
			await this.fetch(eventId);
		},
		async fetch(eventId: string) {
			const result = await getEventById(eventId);
			this.storeEvents([result]);
		},
	},
});

export const useEventStore = createEventStore('event');

export type UseEventStore = typeof useEventStore;
